<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>الشيكات</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة شيك</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        disabled
                        v-model="mycode"
                        label="كود الشيك"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.code')"
                        data-vv-name="code"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-dialog
                        ref="dialog2"
                        v-model="modal2"
                        :return-value.sync="date2"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date2"
                            label="تاريخ السداد"
                            readonly
                            outline
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date2" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modal2 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            color="primary"
                            @click="$refs.dialog2.save(date2)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        type="number"
                        v-model="newItem.value"
                        label="قيمة الشيك "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_bank_deposit"
                        :items="banks"
                        item-text="name"
                        item-value="id"
                        label="أختر بنك الايداع"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_bank_withdrew"
                        :items="banks"
                        item-text="name"
                        item-value="id"
                        label="أختر بنك السحب"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_client"
                        :items="clients"
                        item-text="name"
                        item-value="id"
                        label="أختر العميل"
                        persistent-hint
                        return-object
                        single-line
                        @change="get_all_info"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-dialog
                        ref="dialog1"
                        v-model="modal1"
                        :return-value.sync="date1"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date1"
                            label="التاريخ اليدوي "
                            readonly
                            outline
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date1" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            color="primary"
                            @click="$refs.dialog1.save(date1)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_status"
                        :items="all_status"
                        item-text="name"
                        item-value="id"
                        label="أختر حالة الشيك"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <label for="files" class="btn">اختر صورة الشيك</label>
                      <input
                        id="files"
                        @change="change_file($event)"
                        type="file"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل الشيك</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-dialog
                      ref="dialog3"
                      v-model="modal3"
                      :return-value.sync="date3"
                      persistent
                      lazy
                      full-width
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="date3"
                          label="تاريخ السداد"
                          readonly
                          outline
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date3" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="modal3 = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          flat
                          color="primary"
                          @click="$refs.dialog3.save(date3)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      type="number"
                      v-model="editedItem.value"
                      label="قيمة الشيك "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_status2"
                      :items="all_status"
                      item-text="name"
                      item-value="id"
                      label="أختر حالة الشيك"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form1.manger')"
                      data-vv-name="manger"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <label for="files" class="btn">اختر صورة الشيك</label>
                    <input
                      id="files"
                      @change="change_file2($event)"
                      type="file"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="cheques"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '1'
                ? { 'background-color': 'yellow' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td>
              <img
                style="width:100px;height:100px"
                :src="appUrl + 'cheques/' + props.item.cheque_photos"
                alt=""
              />
            </td>
            <td class="text-xs-right">{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.client.code }}</td>
            <td class="text-xs-right">{{ props.item.client.name }}</td>
            <td class="text-xs-right">{{ props.item.value }}</td>
            <td class="text-xs-right">{{ props.item.date_sadad }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">
              {{ props.item.status == "1" ? "لم يدفع" : "مدفوع" }}
            </td>
            <td class="text-xs-right">
              {{ props.item.client ? props.item.client.name : "" }}
            </td>
            <td class="text-xs-right">
              {{ props.item.bank_deposit ? props.item.bank_deposit.name : "" }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.bank_withdrew ? props.item.bank_withdrew.name : ""
              }}
            </td>
            <td class="justify-center layout px-0">
              <v-icon small class="ml-4" @click="editItem(props.item)">
                edit
              </v-icon>
              <v-icon small @click="deleteItem(props.item)">
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  cheques,
  add_cheque,
  update_cheque,
  delete_cheque,
  clients,
  banks
} from "../config/apiRoute.js";
import { appUrl } from "../config/apiConfig.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    appUrl: "",
    add_dialog: false,
    edit_dialog: false,
    modal1: false,
    modal2: false,
    modal3: false,
    file_image: null,
    file_image2: null,
    date2: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    date3: "",
    headers: [
      {
        text: "صورة الشيك",
        align: "right",
        value: "name"
      },
      { text: " كود", value: "address", align: "right" },
      { text: " كود العميل", value: "address", align: "right" },
      { text: " اسم العميل", value: "address", align: "right" },
      { text: " قيمة الشيك", value: "address", align: "right" },
      { text: " تاريخ السداد", value: "rasid", align: "right" },
      { text: " التاريخ", value: "rasid", align: "right" },
      { text: "الحالة", value: "control", sortable: false, align: "center" },
      { text: "العميل", value: "control", sortable: false, align: "center" },
      {
        text: "البنك الايداع",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: "البنك السحب",
        value: "control",
        sortable: false,
        align: "center"
      },
      { text: "تعديل وحذف", value: "control", sortable: false, align: "center" }
    ],
    select_bank_deposit: { id: "" },
    select_bank_deposit_edit: { id: "" },
    select_bank_withdrew: { id: "" },
    select_bank_withdrew_edit: { id: "" },
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    banks: [],
    cheques: [],
    select_client: { id: "" },
    select_status: { id: "", name: "" },
    select_status2: { id: "", name: "" },
    clients: [],
    editedItem: {
      id: "",
      date_sadad: "",
      value: "",
      status: ""
    },
    newItem: {
      code: "",
      date_sadad: "",
      value: "",
      status: "",
      bank_name: "",
      emp_resposible_name: "",
      cheque_photos: "",
      client_id: "",
      bank_deposit_id: "",
      bank_withdrew_id: "",
      created_at: ""
    }
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.cheques.length > 0) {
        return (this.code =
          parseInt(this.cheques[this.cheques.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.appUrl = appUrl;
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.all_status = [
      { id: "1", name: "لم يدفع" },
      { id: "2", name: "تم الدفع" }
    ];
    this.initialize();
  },

  methods: {
    initialize() {
      clients().then(response => {
        this.clients = response.data;
      });

      banks().then(response => {
        this.banks = response.data;
      });

      cheques().then(response => {
        this.cheques = response.data;
        this.pagination.totalItems = response.data.length;
        this.loading = false;
      });
    },

    change_file(event) {
      this.file_image = event.target.files[0];
    },

    change_file2(event) {
      this.file_image2 = event.target.files[0];
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.initialize();
      this.editedIndex = this.cheques.indexOf(item);
      this.editedItem.id = item.id;
      this.date3 = item.date_sadad;
      this.editedItem.value = item.value;
      item.status == "1" || item.status == 1
        ? (this.select_status2 = { id: "1", name: "لم يدفع" })
        : (this.select_status2 = { id: "2", name: "تم الدفع" });
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.cheques.indexOf(item);

          this.loading = true;
          delete_cheque(item.id).then(response => {
            this.loading = false;
            this.cheques.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          this.newItem.code = this.code;
          this.newItem.date_sadad = this.date2;
          this.newItem.created_at = this.date1;
          this.newItem.status = this.select_status.id;
          this.newItem.bank_deposit_id = this.select_bank_deposit.id;
          this.newItem.bank_withdrew_id = this.select_bank_withdrew.id;
          this.newItem.bank_name = this.select_bank_deposit.name;
          this.newItem.client_id = this.select_client.id;
          var frmData = new FormData();
          frmData.append("cheque", JSON.stringify(this.newItem));
          frmData.append("file", this.file_image);

          add_cheque(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_bank, this.$options.data().select_bank);

            this.cheques.push(response.data);
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_id = this.editedItem.id;

          this.editedItem.date_sadad = this.date3;
          this.editedItem.status = this.select_status2.id;
          var frmData = new FormData();
          frmData.append("cheque", JSON.stringify(this.editedItem));
          this.file_image2 && this.file_image2 != null
            ? frmData.append("file", this.file_image2)
            : "";
          update_cheque(frmData, item_id).then(response => {
            Vue.set(
              this.cheques,
              this.cheques.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
